import { useId } from 'react'
import './input.scss'
import textMk from 'js/textMk'

export default function Input({ type, label, touched, errorText, ...props }) {

    const id = useId()
    const error = (touched) && errorText

    return (
        <div className={textMk('input_container', error && "error")}>
             <label htmlFor={id}>{label}</label>
            {type == "textarea" ? <textarea id={id} {...props} /> : <input id={id} type={type} {...props} />}
            {error && <div className='error_text'>{errorText}</div>}
        </div>
    )
}
